export const mutations = {
  setUser(state, payload) {
    localStorage.setItem('UserInfo', JSON.stringify(payload))
    state.user = payload
  },
  setError(state, payload) {
    state.error = payload
  },
  setLoading(state, payload) {
    state.loading = payload
  },
  setAccessToken(state, payload) {
    localStorage.setItem('AccessToken', payload)
    state.access_token = payload
  },
  setAuth(state, payload) {
    state.isAuth = payload
  },
  setLineId(state, payload) {
    state.line_id = payload
  },
  setLogoUrl(state, payload) {
    state.logoUrl = payload
  },
  setTheme(state, payload) {
    state.theme = payload
  },
  setAppId(state, payload) {
    state.appName = payload
  },
  setAlertImage(state, payload) {
    state.alertImage = payload
  },
  setAlertMessage(state, payload) {
    state.alertMessage = payload
  },
  setPhotoCashback(state, payload) {
    state.img_cashback = payload
  },
  setPhotoAffiliate(state, payload) {
    state.img_affiliate = payload
  },
  setGameList(state, payload) {
    // JSON.parse(payload)

    state.gameList = JSON.stringify(payload)
    // state.gameList = payload
  },
  setPromotion(state, payload) {
    // JSON.parse(payload)
    state.promotion = payload
    // state.gameList = payload
  },
  setPrefix(state, payload) {
    payload.Promotion = [payload.Promotion[0]];
    if(state.prefix == '') localStorage.setItem('Prefix', JSON.stringify(payload))

    state.prefix = JSON.stringify(payload);
    // state.gameList = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js